<template>
    <div id="register">
        <transition name="fade">
            <Loading v-if="isLoading" />
        </transition>
        <div class="content" @change="checkRegister">
            <div class="container">
                <h2 class="title2">會員註冊</h2>
<!--                <p class="center gray">
                    線上投保會員即是要保人，也是繳交保費的付款人。
                </p>-->
                <div class="inline">
                    <div class="inputControl">
                        <div class="inputTitle">帳號</div>
                        <input type="text" id="registerIdNo" class="inputStyle tlf_n_l5 clarity-mask" :class="{ 'alert': check1 }" placeholder="身分證號／居留證號" v-model="acc" @keyup="upper"/>
                        <p class="alertStr"></p>
                    </div>
                    <div class="inputControl">
                        <div class="inputTitle">姓名</div>
                        <input type="text" class="inputStyle tlf_r_f1 clarity-mask" id="registerName" :class="{ 'alert': check2 }" placeholder="請輸入真實姓名" v-model="name"/>
                        <p class="alertStr"></p>
                    </div>
                </div>
                <div class="inline">
                    <div class="inputControl">
                        <div class="inputTitle">手機號碼</div>
                        <input type="text" class="inputStyle tlf_n_l4 clarity-mask" id="registerTel" :class="{ 'alert': check3 }" placeholder="請輸入常用手機號碼" v-model="mob" @keyup="upper"/>
                        <p class="alertStr"></p>
                    </div>
                    <div class="inputControl">
                        <div class="inputTitle">電子郵件</div>
                        <input type="text" class="inputStyle tlf_n_at1 clarity-mask" id="registerEmail" :class="{ 'alert': check4 }" placeholder="請輸入常用email" v-model="email" @keyup="upper"/>
                        <p class="alertStr"></p>
                    </div>
                </div>
                <div class="oneline">
                    <BirthdayChange :dateTimeProps="birthdayAll" :key="reloadYearChangeKey"
                                    @getDateTime="getBirthdayAll" ref="yearRef" nickName="registerBirthday"/>
                </div>
                <p class='attentionTxt'><img src='noticemark.svg' class='attention'>線上投保會員即是要保人，也是繳交保費的付款人。</p>

                <h3 class="blueTitle">同意聲明告知事項</h3>
                <div class="policyDiv clarity-unmask">
                    <div class="policyCon">
                        <h3 class="policyTitle active">個人資料告知事項</h3>
                        <h3 class="policyTitle">會員服務條款</h3>
                        <h3 class="policyTitle">網路投保注意及聲明事項</h3>
                        <h3 class="policyTitle">網路保險服務定型化契約</h3>
                        <div class="policyText" >
                            <div class="textCon" @scroll="onScroll">
                                <div id="policy1" class="policySection" v-html="policy1"></div><!--個人資料告知事項-->
                                <div id="policy2" class="policySection" v-html="policy2"></div><!--會員服務條款-->
                                <div id="policy3" class="policySection" v-html="policy3"></div><!--網路投保注意及聲明事項-->
                                <div id="policy4" class="policySection" v-html="policy4"></div><!--網路保險服務定型化契約-->
                            </div>
                        </div>
                    </div>
                    <p class="pinkText center pinkAlert">請滑動並詳閱條款所載完整內容</p>
                    <p class="attentionTxt"><img src="noticemark.svg" alt="" class='attention'> 本公司所蒐集之個人資料並無共同行銷或屬保險以外且具正當合理關聯之特定項目。</p>
                    <div class="policyCheck">
                        <label class="checkbox" :class="{ 'alert': check5 }" >
                            <input type="checkbox" v-model="agreeExplain" disabled/>
                            <div class="checkStyle"></div>
                            我已閱讀並同意上述說明
                        </label>
                        <label class="checkbox" :class="{ 'alert': check6 }">
                            <input type="checkbox" value="" v-model="agreeMember" disabled/>
                            <div class="checkStyle"></div>
                            同意註冊成為新安東京海上網路投保會員
                        </label>
                        <p class="alertStr"></p>
                    </div>
                </div>
                <div>
                    <label class="checkbox">
                        <input type="checkbox" value="" v-model="isMarketing"/>
                        <div class="checkStyle"></div>
                        我願意接收本公司提供的最新優惠、活動與其他資訊，以便享受更完善的會員服務。(非必填)
                    </label>
                </div>
            </div>
        </div>
        <div class="btnArea">
            <div class="anotherBtn">
                <router-link :to="'/login'" class="btn back register_back_accu">返回</router-link>
                <button class="btn confirm register_go_accu" @click="register">發送註冊驗證碼</button>
            </div>
        </div>
    </div>
</template>
<script setup>
        import Loading from "@/components/loading.vue";
        import _ from "lodash";
        import CheckData from "@/utils/checkData";
        import {popUp} from "@/utils/popUp";
        import {onMounted, ref} from "vue";
        import { postApi } from "@/utils/callApi";
        import gtm from "@/utils/gtmDataLayer";
        import {useRouter} from "vue-router";
        import $ from "jquery"
        import Swal from "sweetalert2";
        import apiConfig from "@/utils/apiConfig";
        import BirthdayChange from "@/components/birthdayChange.vue";

        const router = useRouter();
        let regData = null;
        let jwtInfo = null;
        let startCheck = false;//開始驗證

        const isLoading = ref(false);
        const acc = ref("");
        const name = ref("");
        const mob = ref("");
        const email = ref( "");
        const check1 = ref(false);
        const check2 = ref(false);
        const check3 = ref(false);
        const check4 = ref(false);
        const check5 = ref(false);
        const check6 = ref(false);
        const check7 = ref(false);
        const agreeExplain = ref(false);
        const agreeMember = ref(false);
        const isMarketing = ref(false);
        const termsMember =  ref([]);//CMS會員條款
        const termsMemberTravel = ref([]); //CMS會員條款for旅平險
        const policy1 = ref({});//個人資料告知事項
        const policy2 = ref({});//會員服務條款
        const policy3 = ref({});//CMS旅平險:網路投保注意及聲明事項
        const policy4 = ref({});//網路保險服務定型化契約
        const birthdayAll = ref({});//生日
        const yearRef = ref();
        const reloadYearChangeKey = ref(0);

        //初始載入檢查登入
        const checkLogin = ()=>{
            jwtInfo = JSON.parse(localStorage.getItem("jwtInfo"));
            regData = JSON.parse(sessionStorage.getItem("regData"));

            if(jwtInfo != null){
                router.push('/');
            }else if(regData != null){
                acc.value = regData.acc;
                name.value = regData.name;
                mob.value = regData.mob;
                email.value = regData.email;
                birthdayAll.value = regData.birthday;
                isMarketing.value = regData.isMarketing;
                reloadYearChangeKey.value += 1;
            }
        }

        //輸入身分證時轉大寫
        const upper = _.debounce(()=>{
            if(acc.value !== ""){
                acc.value = acc.value.toString().toUpperCase();
                acc.value = CheckData.convertToHalfWidth(acc.value);
            }
            if(mob.value !== "") {
                mob.value = CheckData.convertToHalfWidth(mob.value);
            }
            if(email.value !== "") {
                email.value = CheckData.convertToHalfWidth(email.value);
            }
        },50)

        //同意聲明告知事項卷軸效果
        const onScroll = ({ target: { scrollTop, clientHeight, scrollHeight }})=>{
            const $Div1 = document.getElementById('policy1').clientHeight;
            const $Div2 = document.getElementById('policy2').clientHeight;
            const $Div3 = document.getElementById('policy3').clientHeight;
            if (scrollTop >= $Div1) {
                $(".policyCon").find('h3').eq(1).addClass('active');
            }
            if (scrollTop >= $Div1 + $Div2) {
                $(".policyCon").find('h3').eq(2).addClass('active');
            }
            if (scrollTop >= $Div1 + $Div2 + $Div3) {
                $(".policyCon").find('h3').eq(3).addClass('active');
            }
            if (scrollTop + clientHeight >= scrollHeight - 100) {
                $(".policyCheck").addClass("active").find("input[type='checkbox']").prop("disabled", false);
            }
        }

        //檢查註冊輸入資料
        const checkRegister = ()=>{
            if(startCheck){
                //身分證檢核
                if(!CheckData.id(acc.value)){
                    check1.value = true;
                }else{
                    check1.value = false;
                }
                //姓名檢核
                if (!CheckData.name(name.value)) {
                    check2.value = true;
                } else {
                    check2.value = false;
                }
                //手機檢核
                if (!CheckData.mobile(mob.value)) {
                    check3.value = true;
                } else {
                    check3.value = false;
                }
                //EMAIL檢核
                if (!CheckData.email(email.value)) {
                    check4.value = true;
                } else {
                    check4.value = false;
                }

                //同意聲明事項檢核
                if(!agreeExplain.value){
                    check5.value = true;
                }else{
                    check5.value = false;
                }
                if(!agreeMember.value){
                    check6.value = true;
                }else{
                    check6.value = false;
                }
                console.log(birthdayAll.value);
                //生日檢查
                if (JSON.stringify(birthdayAll.value) === "{}") {
                    check7.value = true;
                }else{
                    check7.value = false;
                }
                if (birthdayAll.value.year === "" ||birthdayAll.value.year == null
                    || birthdayAll.value.month === "" || birthdayAll.value.month == null
                    || birthdayAll.value.date === "" || birthdayAll.value.date == null) {
                    check7.value = true;
                }else{
                    check7.value = false;
                }
                //觸發 yearChange checkForm();
                yearRef.value?.checkForm(true);

            }
        }
        //發送註冊OTP
        const register = ()=>{
            acc.value = acc.value.trim();//清除空白
            startCheck = true;
            checkRegister();

            let checkFlag = 0;
            let errorMsg = [];
            //身分證檢核
            if(check1.value){
                checkFlag++;
                errorMsg.push("您填入的資料有誤，請確認後重新輸入");
            }
            if(check2.value){
                checkFlag++;
                errorMsg.push("姓名請填寫中文2~50字以內/英文200字以內，中英文一起填寫300字以內，姓名之間不能有數字，請重新輸入");
            }
            if(check3.value){
                checkFlag++;
                errorMsg.push("您輸入的手機號碼有誤，請重新輸入");
            }
            if(check4.value){
                checkFlag++;
                errorMsg.push("您輸入的email格式有誤，請重新輸入");
            }
            if(check5.value){
                checkFlag++;
                errorMsg.push('請確認並勾選同意聲明告知事項');
            }
            if(check6.value){
                checkFlag++;
                errorMsg.push('請確認並勾選同意成為會員');
            }
            if(check7.value){
                checkFlag++;
                errorMsg.push('生日填寫錯誤');
            }

            if(checkFlag === 0){
                isLoading.value = true;
                let regData = {
                    acc: acc.value,
                    birthday:birthdayAll.value,
                    name: name.value,
                    mob: mob.value,
                    email: email.value,
                    isMarketing: isMarketing.value,
                };
                sessionStorage.setItem('regData', JSON.stringify(regData));
                sessionStorage.setItem('otpType','register');
                router.push('/otp');
            }else{
                Swal.fire({
                    title: "填寫資料錯誤",
                    showConfirmButton: false,
                    showCloseButton: true,
                    html: '<img src="error.svg"><p>'+ errorMsg[0] + '</p>',
                })
                isLoading.value = false;
            }
            if(acc.value !== null){
                const fpcInfo = JSON.parse(sessionStorage.getItem("fpcInfo"));
                postApi(apiConfig.event, null, null, null,{
                    tagName: "(新保)保費註冊頁_身分證字號",
                    tagValue: acc.value,
                    sessionId: fpcInfo.sessionId,
                    fpc: fpcInfo.fpc,
                    clarityId: fpcInfo.clarityId,
                    insuranceType: "旅平險",
                })
            }
        }
        const getTermsMember = () =>{
            var data = {
                "Term":[
                    {
                        "insCategory":"Common",
                        "NoteType":[
                            1,2,3
                        ]
                    }
                ]
            }
            postApi(apiConfig.CMSDomain , null, null, null, data)
                .then((response) => {
                    if (response.data.Code === 200) {
                        termsMember.value = response.data.Data;
                        sessionStorage.setItem('termsMember', JSON.stringify(response.data.Data));
                        //取得個條款內容
                        policy1.value = termsMember.value.find(terms => terms.NoteType === 2).Content;
                        policy2.value = termsMember.value.find(terms => terms.NoteType === 1).Content;
                        policy4.value = termsMember.value.find(terms => terms.NoteType === 3).Content;

                    } else {
                        //跳出錯誤
                        Swal.fire({
                            title: "載入錯誤",
                            showConfirmButton: false,
                            showCloseButton: true,
                            html: '<img src="error.svg"><p>條款載入錯誤</p>',
                        });
                    }
                })

            var tra_data = {
                "Term":[
                    {
                        "insCategory":"Travel",
                        "NoteType":[4]
                    }
                ]
            }
            postApi(apiConfig.CMSDomain , null, null, null, tra_data)
                .then((response) => {
                    if (response.data.Code === 200) {
                        termsMemberTravel.value = response.data.Data;
                        sessionStorage.setItem('termsMemberTravel', JSON.stringify(response.data.Data));
                        //取得個條款內容
                        policy3.value = termsMemberTravel.value.find(terms => terms.NoteType === 4).Content;
                    } else {
                        //跳出錯誤
                        Swal.fire({
                            title: "載入錯誤",
                            showConfirmButton: false,
                            showCloseButton: true,
                            html: '<img src="error.svg"><p>條款載入錯誤</p>',
                        });
                    }
                })
        }

        //去除空白 20260305 允許可以輸入空白
        /*const removeSpace = ()=>{
            name.value = name.value.replace(/\s+/g, "");
        }*/

        //取得生日資料
        const getBirthdayAll = (data) => {
            birthdayAll.value = data;
        }

        onMounted(()=>{
            popUp();//公告系統
            getTermsMember();
            gtm.pageViewEvent();
            checkLogin();
        })

</script>
<style lang="scss">
#register {
    .content {
        p.center.gray{
            font-size:14px;
            margin:10px 0 20px;
        }
        .title2 {
            border-bottom: 1px solid $btnGray;
            padding-bottom: 30px;
        }
    }

    .policyCheck {
        opacity: 0.3;
        transition: opacity 100ms ease-in-out;
        color:$textColor;
        font-weight:500;
        @media screen and (max-width: $small) {font-size:16px;}
        &.active {
            opacity: 1;
        }
        .checkbox {
            margin: 10px 0;
            display: block;
            a {
                color: $blue-700;
            }
        }
    }
}</style>
